import { NgModule } from '@angular/core';  
import { CommonModule } from '@angular/common';
import {ConfirmDialogComponent} from './confirm-dialog.component';  
import {ConfirmDialogService} from './services/confirm-dialog.service';  
  
@NgModule({ 
    imports:[CommonModule],
    declarations: [ConfirmDialogComponent
    ],  
    exports: [  
        ConfirmDialogComponent  
    ],providers:[  
       ConfirmDialogService  
    ]  
})  
export class ConfirmDialogModule  
{  
}  